/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styles from "./DeveloperMenuModal.module.css";
import {
  FloButtonTabs,
  FloModal,
  FloModalBodyProps,
  FloMultipleSlider,
} from "components";
import { useTranslation } from "react-i18next";
import Message from "containers/common/Message";
import { Col, Row } from "react-bootstrap";
import { Location, Device, DeveloperMenuSettings } from "model";
import ContentLoader from "react-content-loader";
import Toggle from "react-toggle";
import "react-toggle/style.css";
interface DeveloperMenuModalBodyProps extends FloModalBodyProps {
  locations: Location[];
  menuSettings: DeveloperMenuSettings;
  device: Device;
  onChange: (menuSettings: DeveloperMenuSettings) => void;
  onSave: (device: Device, settings: DeveloperMenuSettings) => void;
}

const DeveloperMenuModalBody: React.FC<DeveloperMenuModalBodyProps> =
  React.memo(
    ({ locations, device, menuSettings, onChange, onSave, bindSubmitForm }) => {
      const { t } = useTranslation();

      bindSubmitForm(async () => {
        onSave(device, menuSettings);
        onChange(menuSettings);
      });

      const [selectedCat, setSelectedCat] = useState(menuSettings.playerAction);
      const [customTelemetryEnabled, setCustomTelemetryEnabled] = useState(
        menuSettings.playerAction !== "disabled"
      );

      return (
        <>
          <Row className={styles.bodyContainer}>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Message />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className={styles.container}>
                    <Col
                      xs={{ span: 4, offset: 0 }}
                      className={styles.smallerColPadding}
                    >
                      Custom telemetry
                    </Col>
                    <Col
                      xs={{ span: 4, offset: 6 }}
                      className={styles.smallerColPadding}
                    >
                      <Toggle
                        id="developer-menu-enabled"
                        icons={false}
                        disabled={false}
                        className={styles.toggle}
                        checked={customTelemetryEnabled}
                        onChange={() => {
                          setCustomTelemetryEnabled(!customTelemetryEnabled);
                          if (customTelemetryEnabled) {
                            menuSettings.playerAction = "disabled";
                            menuSettings.playerMinPressure = 0;
                            setSelectedCat("");
                          } else if (!selectedCat.includes("cat") ) {
                            menuSettings.playerAction = "constant";
                            menuSettings.playerMinPressure = 0;
                          } else {
                            menuSettings.playerAction = selectedCat;
                          }
                        }}
                      />
                    </Col>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs="12">
                  <div className={styles.groupContainer}>
                    <div className={styles.sliderGroup}>
                      <Col
                        xs={{ span: 4, offset: 0 }}
                        className={styles.smallerColPadding}
                      >
                        <div className={styles.title}>Flow Rate</div>
                      </Col>
                      <FloMultipleSlider
                        min={0}
                        max={25}
                        step={1}
                        minValue={menuSettings.playerFlow}
                        maxValue={0}
                        disabled={!customTelemetryEnabled}
                        rightSymbol={"gpm"}
                        leftSymbol={""}
                        onChange={(playerFlow: number) => {
                          onChange({
                            ...menuSettings,
                            playerFlow,
                          });
                        }}
                        onMultipleChange={() => {}}
                      />
                    </div>
                    <div className={styles.sliderGroup}>
                      <Col
                        xs={{ span: 4, offset: 0 }}
                        className={styles.smallerColPadding}
                      >
                        <div className={styles.title}>Temperature</div>
                      </Col>
                      <div className={styles.sliderGroup}>
                        <FloMultipleSlider
                          min={0}
                          max={100}
                          step={1}
                          minValue={menuSettings.playerTemperature}
                          maxValue={0}
                          disabled={!customTelemetryEnabled}
                          rightSymbol={"ºF"}
                          leftSymbol={""}
                          onChange={(playerTemperature: number) => {
                            onChange({
                              ...menuSettings,
                              playerTemperature,
                            });
                          }}
                          onMultipleChange={() => {}}
                        />
                      </div>
                      <Col
                        xs={{ span: 4, offset: 0 }}
                        className={styles.smallerColPadding}
                      >
                        <div className={styles.title}>Pressure</div>
                      </Col>
                      {selectedCat.includes("cat") ? (
                        <FloMultipleSlider
                          min={0}
                          max={160}
                          step={1}
                          minValue={menuSettings.playerMinPressure}
                          maxValue={menuSettings.playerPressure}
                          rightSymbol={"PSI"}
                          leftSymbol={"PSI"}
                          disabled={!customTelemetryEnabled}
                          onChange={() => {}}
                          onMultipleChange={(values: readonly number[]) => {
                            let playerMinPressure = values[0];
                            let playerPressure = values[1];
                            menuSettings.playerPressure = playerPressure;
                            menuSettings.playerMinPressure = playerMinPressure;

                            onChange({
                              ...menuSettings,
                            });
                          }}
                        />
                      ) : (
                        <FloMultipleSlider
                          min={0}
                          max={160}
                          step={1}
                          minValue={menuSettings.playerPressure}
                          maxValue={0}
                          rightSymbol={"PSI"}
                          leftSymbol={""}
                          disabled={!customTelemetryEnabled}
                          onChange={(playerPressure: number) => {
                            onChange({
                              ...menuSettings,
                              playerPressure,
                            });
                          }}
                          onMultipleChange={() => {}}
                        />
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <FloButtonTabs
                    className={styles.tabsContainer}
                    tabs={[
                      { id: "cat1", label: () => t("Cat1 Drip") },
                      { id: "cat2", label: () => t("Cat2 Drip") },
                      { id: "cat3", label: () => t("Cat3 Drip") },
                      { id: "cat4", label: () => t("Cat4 Drip") },
                    ]}
                    selected={selectedCat}
                    onSelect={(currentCat) => {
                      if(customTelemetryEnabled){
                        setSelectedCat(currentCat);
                        menuSettings.playerAction = currentCat;
                      }
                    }}
                  >
                    <div></div>
                  </FloButtonTabs>
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      );
    }
  );

const ThresholdsSkeleton: React.FC<{}> = () => (
  <ContentLoader height={400} width={"100%"} speed={3}>
    <rect x="0" y="0" rx="3" ry="3" width="200" height="20" />

    <rect x="0" y="50" rx="3" ry="3" width="80" height="24" />
    <rect x="90" y="50" rx="3" ry="3" width="110" height="24" />
    <rect x="210" y="50" rx="3" ry="3" width="60" height="24" />
    <rect x="280" y="50" rx="3" ry="3" width="130" height="24" />

    <rect x="0" y="120" rx="3" ry="3" width="140" height="20" />
    <rect x="0" y="150" rx="3" ry="3" width={"100%"} height="30" />

    <rect x="0" y="210" rx="3" ry="3" width="140" height="20" />
    <rect x="0" y="240" rx="3" ry="3" width={"100%"} height="30" />
  </ContentLoader>
);

type DeveloperMenuModalProps = {
  show: boolean;
  onHide: () => void;
  onSave: () => void;
  isSubmitting: boolean;
  locations: Location[];
  device: Device;
  settings: DeveloperMenuSettings | null;
  fetchDeveloperMenuSettings: (deviceId: string) => void;
  updateDeveloperMenuSettings: (
    deviceId: string,
    settings: DeveloperMenuSettings
  ) => void;
  changeDeveloperMenuSettings: (
    settings: DeveloperMenuSettings
  ) => void;
  clearMessage: () => void;
  hasError: boolean;
};

export const DeveloperMenuModal: React.FC<DeveloperMenuModalProps> = React.memo(
  ({
    show,
    locations,
    device,
    settings,
    fetchDeveloperMenuSettings,
    updateDeveloperMenuSettings,
    changeDeveloperMenuSettings,
    clearMessage,
    hasError,
    ...rest
  }) => {
    const { t } = useTranslation();

    useEffect(() => {
      if (show) {
        clearMessage();
        fetchDeveloperMenuSettings(device.id);
      }
    }, [show]);

    return (
      <FloModal
        {...rest}
        show={show}
        name="set-thresholds-modal"
        title={t("Developer Menu")}
        className={styles.root}
        disableButtons={settings === null}
        closeOnSubmit={true}
        body={(props) =>
          settings ? (
            <DeveloperMenuModalBody
              {...props}
              locations={locations}
              device={device}
              menuSettings={settings}
              onChange={(settings) =>
                changeDeveloperMenuSettings(settings)
              }
              onSave={(device) =>
                updateDeveloperMenuSettings(device.id, settings)
              }
            />
          ) : (
            <ThresholdsSkeleton />
          )
        }
      />
    );
  }
);
